import "./Patient.scss";
import Buttons from "../../../components/Buttons/Buttons";
import Spinner from "../../../components/Spinner/Spinner";
import { BackArrow } from "../../../assets/icons-components/Icons";
import usePatientForm from "./usePatientForm";
import PatientFormFields from "./PatientFormFields";
import { onKeyActivate } from "../../../utils/a11y";

const Patient = () => {
  const {
    errors,
    formData,
    isLoading,
    gender,
    device,
    data,
    isEditing,
    resetPassword,
    handleChange,
    handleCheckboxChange,
    handleRemoveDevice,
    handleDeviceSelect,
    onResetPasswordClick,
    handleSubmit,
    handleTable,
  } = usePatientForm();

  return (
    <div className="main1">
            {isLoading && (
        <div className="loader-container">
          <div className="loader">
            <Spinner />
          </div>
        </div>
      )}
      <div className="main1_header">
        <div className="main1_header_left">
          <div
            className="main1_header_left_arrow"
            onClick={handleTable}
            onKeyDown={onKeyActivate(handleTable)}
            role="button"
            tabIndex={0}
          >
            <BackArrow onClick={handleTable} />
            <h3>{isEditing ? "Edit Patient" : "Add Patient"}</h3>
          </div>
        </div>
      </div>
      <div className="patientdetails">
        <div className="patientdetails_container">
          <PatientFormFields
            formData={formData}
            errors={errors}
            gender={gender}
            device={device}
            data={data}
            isEditing={isEditing}
            resetPassword={resetPassword}
            onChange={handleChange}
            onCheckboxChange={handleCheckboxChange}
            onRemoveDevice={handleRemoveDevice}
            onDeviceSelect={handleDeviceSelect}
            onResetPasswordClick={onResetPasswordClick}
          />
        </div>
        <div className="patientdetails_button-sec">
          <div className="patientdetails_button-sec_buttons">
            <Buttons
              text="Cancel"
              type="button"
              onClick={handleTable}
              className="cancel-button"
              variant="secondary"
              style={{ width: "100px" }}
            />
            <Buttons
              text="Save"
              type="button"
              onClick={handleSubmit}
              className="save-button"
              variant="primary"
              style={{ width: "100px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Patient;
